<div class="input-group fiori3-input-group" [class.full-width]="dynamicWidth" [class.no-label]="config ? config.hideLabel : false">
  @if (label && label.key) {
    <label>
      {{label.key | translate}}
    </label>
  }
  @if (infoMessage) {
    <cpq-info class="cpq-info-icon float-right" [message]="infoMessage" (onInfoClick)="infoClicked()"></cpq-info>
  }
  <input #inputField id="{{name}}" [disabled]="disabled" class="form-control" [ngClass]="customClass" [type]="type" [(ngModel)]="value" placeholder="{{ label?.placeholder ? (label.placeholder | translate)  : ''}}"
    (blur)="touched($event)" (keydown)="onEnter($event)" (focusout)='onFocusOut.emit($event)' autocomplete="off" [attr.tabindex]='tabindex' />
    @if (showSearchIcon && !value) {
      <span class="sap-icon flex-center">&#xe00d;</span>
    }
    @if (showSearchIcon && value) {
      <span class="sap-icon flex-center" (click)="value = ''">&#xe03e;</span>
    }
    @if (config) {
      <span class="formula-builder">
        <button class="btn btn-link button-link" (click)="openFormulaBuilder(value)" [ngClass]="{'fb-disabled': disabled }">
          <span class="sap-icon">&#xe19f;</span>
          @if (!config.hideLabel) {
            {{'FormulaBuilder.Title' | translate}}
          }
        </button>
      </span>
    }
  </div>
